import { ActionIcon, Indicator, Tooltip } from '@mantine/core';
import { IconBell } from '@tabler/icons-react';

/**
 * Notification Bell Component
 * Placeholder for future notification system
 * TODO: Integrate with SDK's notification hub when available
 */
export default function NotificationBell() {
  // TODO: Replace with real notification count from SDK
  const notificationCount = 0;
  const hasNotifications = notificationCount > 0;

  const handleClick = () => {
    // TODO: Open notifications drawer/modal
    console.log('Notifications clicked - to be implemented');
  };

  return (
    <Tooltip label="Notifications (coming soon)" position="bottom">
      <Indicator
        inline
        label={notificationCount}
        size={16}
        disabled={!hasNotifications}
        color="red"
        offset={7}
      >
        <ActionIcon
          variant="default"
          size="lg"
          onClick={handleClick}
          aria-label="Notifications"
          disabled={!hasNotifications}
        >
          <IconBell size={18} />
        </ActionIcon>
      </Indicator>
    </Tooltip>
  );
}
